import React, { Component } from 'react';
import { Select } from 'antd';
import { Row, Col } from 'antd';
import { groupBy, filter, orderBy, forIn, get } from 'lodash';
import { connect } from 'react-redux';

import { FormTitle, StyledFormItem, StyledSelect } from 'components/Styled';
import categories from 'data/categories';

const { Option } = Select;

class CategorySelect extends Component {
  mainCategoryList = [];
  groupedCategories = [];

  componentDidMount() {
    this.groupedCategories = groupBy(
      filter(this.props.categories, 'enable'),
      'parent'
    );

    forIn(this.groupedCategories, (value, key) => {
      this.groupedCategories[key] = orderBy(value, 'order', 'asc');
    });

    this.mainCategoryList = this.groupedCategories['null'];

    for (let i = 0; i < this.groupedCategories['null'].length; i++) {
      if (
        !get(
          this.groupedCategories[this.groupedCategories['null'][i]['id']],
          'length'
        )
      )
        this.groupedCategories['null'][i] = false;
    }
  }

  render() {
    return (
      <React.Fragment>
        <FormTitle paddingBottom={5}>
          {this.props.t('items.form.item_category_label')}
        </FormTitle>
        <Row gutter={14}>
          <Col span={12}>
            <StyledSelect
              size="large"
              placeholder={this.props.t('common.select')}
              value={this.props.mainCategory || undefined}
              onChange={this.props.onMainCategoryChange}>
              {this.mainCategoryList.map(r =>
                r ? (
                  <Option key={r.id}>{r.name[this.props.t('key')]}</Option>
                ) : null
              )}
            </StyledSelect>
          </Col>
          <Col span={12}>
            <StyledFormItem
              validateStatus={
                (this.props['categoryChanged'] &&
                  this.props['categoryStatus']) ||
                ''
              }
              help={
                this.props['categoryChanged'] && this.props['categoryHelp']
              }>
              <StyledSelect
                size="large"
                placeholder={this.props.t('common.select')}
                value={this.props.category || undefined}
                onChange={this.props.onCategoryChange}
                onBlur={this.props.onCategoryBlur}>
                {(this.props.mainCategory && this.groupedCategories[this.props.mainCategory] || []).map(
                  c => c ? (
                    <Option key={c.id}>{c.name[this.props.t('key')]}</Option>
                  ) : null
                )}
              </StyledSelect>
            </StyledFormItem>
          </Col>
        </Row>
      </React.Fragment>
    );
  }
}

const mapStateToProps = state => {
  return {
    categories: state.shipments.categories || categories
  };
};

export default connect(mapStateToProps)(CategorySelect);
